// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hu-0";